import React from 'react';

const ActivityContainer = () => {
  return <div>Activity Page</div>;
};

export default ActivityContainer;
